import React from 'react';
import PageLayout from '../app/layout/PageLayout';
import { useRightPanel } from '../app/layout/RightPanel';
import useRouteHandle from '../app/useRouteHandle';
import KeyboardShortcutsPanel from '../help/shortcuts/KeyboardShortcutsPanel';
import useShortcut from '../utils/useShortcut';
import PublicSidebar from './PublicSidebar';
import useIsPublicDocumentationView from './useIsPublicDocumentationView';

const PublicApp = () => {
  const { routeName } = useRouteHandle();
  const isPublicDocumentationView = useIsPublicDocumentationView();
  const { openRightPanel } = useRightPanel();

  useShortcut(
    'mod+/',
    (e) => {
      e.preventDefault();
      openRightPanel(<KeyboardShortcutsPanel />);
    },
    { global: true },
  );

  return (
    <PageLayout.Root
      elements={{
        sidebar: isPublicDocumentationView ? <PublicSidebar /> : undefined,
      }}
      routeName={routeName}
    />
  );
};

export default PublicApp;
